import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import config from '../config';

export const useMaintenanceMode = () => {
    const [isMaintenanceMode, setIsMaintenanceMode] = useState(false);
    const [loading, setLoading] = useState(true);
    const location = useLocation();

    useEffect(() => {
        checkMaintenanceMode();
        
        // Check maintenance mode every 30 seconds
        const interval = setInterval(() => {
            checkMaintenanceMode();
        }, 30000);

        return () => clearInterval(interval);
    }, []);

    const checkMaintenanceMode = async () => {
        try {
            const response = await fetch(`${config.api.API_URL}/health`);
            
            // If we get a 503 status, we're in maintenance mode
            if (response.status === 503) {
                setIsMaintenanceMode(true);
            } else {
                setIsMaintenanceMode(false);
            }
        } catch (error) {
            // If the API is completely down, don't consider it maintenance mode
            setIsMaintenanceMode(false);
        } finally {
            setLoading(false);
        }
    };

    // Check if current user is admin (has valid token)
    const isAdmin = () => {
        const authUser = sessionStorage.getItem('authUser');
        if (authUser) {
            try {
                const parsed = JSON.parse(authUser);
                const user = parsed.user || parsed;
                return user?.level_id === 1;
            } catch (error) {
                return false;
            }
        }
        return false;
    };

    // Don't show maintenance page on login routes or for admins
    const shouldShowMaintenancePage = isMaintenanceMode && 
        !loading && 
        !location.pathname.includes('/login') && 
        !location.pathname.includes('/logout') &&
        !location.pathname.includes('/register') &&
        !isAdmin();

    return { isMaintenanceMode, shouldShowMaintenancePage, loading };
};